import { Component} from '@angular/core';

@Component({
  selector: 'app-UnauthenticatedPage-session-timeout',
  template: `
          <div class="col-lg-12 p-4 session-page">

            <div class="d-flex justify-content-center">
              <img src="assets/images/maintenance/media_session_timeout.png">
            </div>
             <div class="text-center session-page-content">
                <p class="f-20 m-0 f-w-400 mb-4">{{errorMessage}}</p>   
            </div>
        </div>
        `,
})
export class UnauthenticatedPageSessionTimeoutComponent {
    errorMessage : string = '';

    ngOnInit() {
        this.errorMessage = history.state.errorMessage;
      }

}